// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"ye_a bik_a bik_x","StrollerDetailRating__muted":"ye_b bik_fo"};